<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="upsertBusiness" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Business Name" prop="businessName">
            <el-input v-model="form.businessName" placeholder="Business Name"></el-input>
          </el-form-item>
          <el-form-item label="Rep. Name" prop="repName">
            <el-input v-model="form.repName" placeholder="Representative Name"></el-input>
          </el-form-item>
          <el-form-item label="Driver's License" prop="stateId">
            <el-input v-model="form.stateId" placeholder="Representative Driver's License"></el-input>
          </el-form-item>
          <el-form-item label="Address" prop="address">
            <el-input v-model="form.address" placeholder="Address"></el-input>
          </el-form-item>
          <el-form-item label="City" prop="city">
            <el-input v-model="form.city" placeholder="City"></el-input>
          </el-form-item>
          <el-form-item label="State" prop="state">
            <us-state-select v-model="form.state"></us-state-select>
          </el-form-item>
          <el-form-item label="Zip" prop="zip">
            <el-input v-model="form.zip" placeholder="Zipcode"></el-input>
          </el-form-item>
          <el-form-item label="Phone">
            <el-input v-model="form.phone" placeholder="Phone"></el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input v-model="form.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item label="RAF Code" v-show="form.id === undefined">
            <el-select v-model="form.rafCode" placeholder="Select RAF Code" filterable>
              <el-option v-for="item in unassignedRafCodes" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="Office" prop="officeId" v-if="isAdmin">
            <el-select v-model="form.officeId" value-key="id" :disabled="allUserOffices.length === 1">
              <el-option v-for="item in formattedUserOffices" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="upsertOffice">Update Business</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import trim from 'lodash/trim';
import map from 'lodash/map';
import api from '@/api';
import Business from '@/model/Business';
import { Required, Integer } from '@/util/formValidators';
import UsStateSelect from '@/components/form-item/USStateSelect.vue';
import OfficeToRefType from '@/util/OfficeToRefType';

export default {
  props: {
    business: {
      type: Object,
      default() {
        return new Business();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      unassignedRafCodes: [],
      form: new Business(),
      rules: {
        businessName: [Required],
        repName: [Required],
        stateId: [Required, Integer],
        officeId: [Required],
      },
    };
  },
  methods: {
    upsertOffice() {
      this.errorMessage = null;
      this.$refs.upsertBusiness.validate((valid) => {
        if (valid) {
          // trim all values
          Object.keys(this.form).forEach((key) => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = trim(this.form[key]);
            }
          });

          const business = new Business(this.form);

          this.isLoading = true;

          api.business.upsert(business).then((response) => {
            this.$emit('businessUpdated', response.data);
            this.closeDialog();
          }).catch((e) => {
            this.errorMessage = get(e, 'response.data', 'An Error Occurred. Please try again.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.errorMessage = null;
      this.form = new Business(this.business);
      this.$emit('close');
    },
    async fetchUnassignedRafCodes() {
      try {
        const response = await api.referral.getUnassignedCodes();
        this.unassignedRafCodes = response.data;
      } catch (e) {
        this.$message({
          type: 'error',
          title: 'Error',
          message: `An error occurred fetching available RAF codes. ${e.message}`,
        });
      }
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
      'activeOffice',
      'allUserOffices',
    ]),
    formattedUserOffices() {
      return map(this.allUserOffices, office => OfficeToRefType(office));
    },
  },
  watch: {
    office() {
      this.form = new Business(this.business);
    },
  },
  created() {
    if (this.business) {
      this.form = new Business(this.business);
    }

    if (this.business.id === undefined) {
      this.fetchUnassignedRafCodes();
    }
  },
  components: {
    UsStateSelect,
  },
};

</script>
